import { AlertDialog, Button, useControllableState } from '@buffer-mono/popcorn'

import type { ChannelGroup_ChannelGroup } from '../hooks/useChannelGroups'
import { useDeleteChannelGroup } from '../hooks/useDeleteChannelGroup'

interface DeleteConfirmationDialogProps {
  channelGroup: ChannelGroup_ChannelGroup
  open: boolean
  onOpenChange: (open: boolean) => void
  onDeleteSuccess?: () => void
}

export const DeleteConfirmationDialog = ({
  channelGroup,
  onOpenChange,
  open,
  onDeleteSuccess,
}: DeleteConfirmationDialogProps): JSX.Element => {
  const [isOpenState, setIsOpenState] = useControllableState({
    prop: open,
    defaultProp: false,
    onChange: onOpenChange,
  })

  const { deleteChannelGroup, loading } = useDeleteChannelGroup()

  const handleDeleteChannelGroup = async (): Promise<void> => {
    await deleteChannelGroup({ channelGroupId: String(channelGroup.id) })
    if (onDeleteSuccess) {
      onDeleteSuccess()
    }
  }

  return (
    <AlertDialog open={isOpenState} onOpenChange={setIsOpenState}>
      <AlertDialog.Content>
        <AlertDialog.Title>Delete Channel Group</AlertDialog.Title>
        <AlertDialog.Description>
          You&apos;re about to delete the <strong>{channelGroup.name}</strong>{' '}
          channel group. This can&apos;t be undone. All channels in the group
          will stay connected.
        </AlertDialog.Description>

        <AlertDialog.Actions>
          <AlertDialog.Cancel>
            <Button variant="tertiary" size="large">
              Cancel
            </Button>
          </AlertDialog.Cancel>

          <Button
            variant="critical"
            size="large"
            loading={loading}
            disabled={loading}
            onClick={() => {
              void handleDeleteChannelGroup()
            }}
          >
            Confirm and Delete
          </Button>
        </AlertDialog.Actions>
      </AlertDialog.Content>
    </AlertDialog>
  )
}
